import { useEffect } from "react";

interface ConfirmationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    message: string;
    setIsConfirmationOpen: (isOpen: boolean) => void;

}

export const ConfirmationModal = ({ open, onClose, onConfirm, message, setIsConfirmationOpen }: ConfirmationModalProps) => {
    useEffect(() => {
        setIsConfirmationOpen(open);
    }, [open, setIsConfirmationOpen]);
    
    if (!open) return null;

    const handleOverlayClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        onClose();
    };
    

    return (
        <div className="fixed inset-0 z-[60] overflow-y-auto" onClick={(e) => e.stopPropagation()}>
            <div
                className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
                onClick={handleOverlayClick}
            />
            <div className="flex items-center justify-center min-h-screen p-4" onClick={(e) => e.stopPropagation()}>
                <div 
                    className="relative bg-white rounded-lg shadow-xl p-6 max-w-md mx-auto z-[60]"
                    onClick={(e) => e.stopPropagation()}
                >
                    <p className="mb-4">{message}</p>
                    <div className="flex justify-end space-x-2">
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                onClose();
                            }}
                            className="px-4 py-2 bg-gray-200 rounded"
                        >
                            Cancel
                        </button>
                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                onConfirm();
                            }}
                            className="px-4 py-2 bg-blue-500 text-white rounded"
                        >
                            Confirm
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};